import React, { type FC } from "react";
import { useUser } from "clientState/useUser";
import {
  useTrackElement,
  useTracking,
  useTranslation,
} from "@edreamsodigeo/frontend-core";
import {
  Body,
  Flex,
  Heading,
  SystemModalContent,
} from "@edreamsodigeo/prisma-design-system";

import {
  DATAMESH_ONCLICK_GUEST_EVENT,
  DATAMESH_ONCLICK_SIGNIN_EVENT,
  TRACKING_ACTION,
  TRACKING_CATEGORY,
  TRACKING_LABEL_ONCLICK,
  TRACKING_LABEL_ONCLICK_AS_GUEST,
} from "./config/tracking";
import type { UserVerificationModalContentProps } from "./contract";
import UserVerificationModalButton from "./UserVerificationModalButton";

const UserVerificationModalContent: FC<UserVerificationModalContentProps> = ({
  onClick,
  onClose,
}) => {
  const { t } = useTranslation();
  const { trackEvent } = useTracking();
  const { user } = useUser();
  const userName = user?.displayName || "";

  const handleClick = (label: string): void => {
    trackEvent({
      category: TRACKING_CATEGORY,
      action: TRACKING_ACTION,
      label,
    });

    onClick();
    onClose();
  };

  const trackClickSigninRef = useTrackElement<HTMLButtonElement>(
    ["click"],
    DATAMESH_ONCLICK_SIGNIN_EVENT,
  );
  const trackClickGuestRef = useTrackElement<HTMLButtonElement>(
    ["click"],
    DATAMESH_ONCLICK_GUEST_EVENT,
  );
  return (
    <SystemModalContent>
      <Flex gap="base" justifyContent="center" flexDirection="column">
        <Heading type="2" textAlign="center" weight="medium" color="neutral.90">
          {t("meta.login.userConfirmation.title", { userName })}
        </Heading>
        <Body type="base" textAlign="center" weight="normal" color="neutral.80">
          {t("meta.login.userConfirmation.description")}
        </Body>
      </Flex>

      <Flex flexDirection="column" gap="base" mt="big">
        <UserVerificationModalButton
          onClick={() => handleClick(TRACKING_LABEL_ONCLICK)}
          ref={trackClickSigninRef}
        >
          {t("meta.login.userConfirmation.button.signin")}
        </UserVerificationModalButton>
        <UserVerificationModalButton
          onClick={() => handleClick(TRACKING_LABEL_ONCLICK_AS_GUEST)}
          ref={trackClickGuestRef}
        >
          {t("meta.login.userConfirmation.button.continue")}
        </UserVerificationModalButton>
      </Flex>
    </SystemModalContent>
  );
};

export default UserVerificationModalContent;
